/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery( document ).ready(function() {

document.body.addEventListener('click', function (event) {
  if ( event.target.classList.contains('cta_mail') || event.target.classList.contains('cta_call') ) {
     console.log("open contact");
    jQuery(".cta_contact_form").removeClass('open');
      jQuery("#cta_contact_form").addClass('open');
  }
})

document.body.addEventListener('click', function (event) {
  if ( event.target.classList.contains('cta_fotos') ) {
     console.log("open more foto");
    jQuery(".cta_contact_form").removeClass('open');
      jQuery("#cta_foto_form").addClass('open');

    jQuery("#product_item").attr('value', window.location.href);
    
  }
})

  jQuery(".cta_contact_form .closer").click(function() {
      jQuery(".cta_contact_form").removeClass('open');
    });

$('.Linklist .Linklist__Item a:contains(Asscher)').addClass('cut-asscher is-cut-link');
$('.Linklist .Linklist__Item a:contains(Cushion)').addClass('cut-cushion is-cut-link');
$('.Linklist .Linklist__Item a:contains(Emerald)').addClass('cut-emerald is-cut-link');
$('.Linklist .Linklist__Item a:contains(Oval)').addClass('cut-oval is-cut-link');
$('.Linklist .Linklist__Item a:contains(Asscher)').addClass('cut-asscher is-cut-link');
$('.Linklist .Linklist__Item a:contains(Pear)').addClass('cut-pear is-cut-link');
$('.Linklist .Linklist__Item a:contains(Heart)').not('.Linklist .Linklist__Item a:contains(Heart of Gold)').addClass('cut-heart is-cut-link');
$('.Linklist .Linklist__Item a:contains(Round)').addClass('cut-round is-cut-link');
$('.Linklist .Linklist__Item a:contains(Marquise)').addClass('cut-marquise is-cut-link');
  $('.Linklist .Linklist__Item a:contains(Radiant)').addClass('cut-radiant is-cut-link');


  $('.Linklist .Linklist__Item a:contains(Solitaire Rings)').addClass('cut-solitaire is-cut-link');
  $('.Linklist .Linklist__Item a:contains(Threestone Rings)').addClass('cut-threestone is-cut-link');
  $('.Linklist .Linklist__Item a:contains(Pavé Rings)').addClass('cut-pave is-cut-link');
  $('.Linklist .Linklist__Item a:contains(Halo Rings)').addClass('cut-halo is-cut-link');
  $('.MegaMenu__Inner .MegaMenu__Item:nth-of-type(3) .Linklist .Linklist__Item a:contains(Eternity Rings)').addClass('cut-eternity is-cut-link');


$('.CollectionFilters .Linklist__Item label:contains(Asscher)').addClass('cut-asscher is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Cushion)').addClass('cut-cushion is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Emerald)').addClass('cut-emerald is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Oval)').addClass('cut-oval is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Asscher)').addClass('cut-asscher is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Pear)').addClass('cut-pear is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Heart)').addClass('cut-heart is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Round)').addClass('cut-round is-cut-link');
$('.CollectionFilters .Linklist__Item label:contains(Marquise)').addClass('cut-marquise is-cut-link');
  $('.CollectionFilters .Linklist__Item label:contains(Radiant)').addClass('cut-radiant is-cut-link');

$(document).on("scroll",function(){
    if ($(document).scrollTop() > 130){
      $("#section-header").addClass("small-header");
    }else {
      $("#section-header").removeClass("small-header");
    }
  });

  document.addEventListener('variant:changed', function(event) {
     var variant = event.detail.variant; // Gives you access to the whole variant details
     jQuery('.ProductForm__BuyButtons > .cta_inner_holder').remove();
      if( ( typeof from_product != 'undefined' && from_product == true ) || (typeof variant != 'undefined' && variant.name.includes('Glacier - 16.00ct')) ) {
         console.log('is from product add Form');
         jQuery('.ProductForm__BuyButtons').append( contact_stuff );
      }
  });

  if( (typeof from_product != 'undefined' && from_product == true) || (typeof window.var_special != 'undefined' && window.var_special == true) ) {
    console.log('is from product add Form');
    jQuery('.ProductForm__BuyButtons > .cta_inner_holder').remove();
    jQuery('.ProductForm__BuyButtons').append( contact_stuff );
  }

});